import { Input } from "@nextui-org/react";
import comentIcon from "../../assets/comentIcon.svg";
import logoIvi from "../../assets/logo.svg";
import question from "../../assets/question.svg";
import ButtonComponent from "../../components/ButtonComponent";
import LeftHomeComponent from "../../components/leftHomeComponent/LeftHomeComponent";
import MainHomeComponent from "../../components/MainHomeComponent/MainHomeComponent";
import RightHomeComponent from "../../components/RightHomeComponent/RightHomeComponent";
import "./dadosParceiro.css";
import { description, title } from "./texts";
import { useContext, useEffect, useRef, useState } from "react";
import { SessionContext } from "../../context/session";
import { isValidEmail } from "../../services/validations";
import { useNavigate } from "react-router-dom";
import { DadosParceiroType } from "../../services/onboarding";
import CalculatorModal from "../../components/modal/CalculatorModal/CalculatorModal";
import { NewModalRef } from "../../components/modal/NewModal/NewModal";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { useTenantStore } from "../../stores/tenant/use-tenant-store";
import { formatCPF, getDigits, isCPF, removeExcessiveDigits } from "../../utils/document-utils";
import { FluxoType } from "../../stores/tenant/tenant.types";

export const DadosParceiro = () => {
  const { getItemSession, setItemSession } = useContext(SessionContext);
  const { type, partner } = useTenantStore();

  const initialData = !!getItemSession("DadosParceiro") ? JSON.parse(getItemSession("DadosParceiro")!) : null;
  const navigate = useNavigate();

  const [saleOrSellerIdentifier, setSaleOrSellerIdentifier] = useState<string | undefined>(initialData?.idSalesforce);
  const [dealerEmail, setDealerEmail] = useState<string | undefined>(initialData?.dealerEmail);

  const [dealerEmailChanged, setDealerEmailChanged] = useState(false);

  const isDealerEmailValid = dealerEmail && isValidEmail(dealerEmail);
  const isFormValid = isDealerEmailValid;

  const saleOrSellerIdentifierMeetsCriteria =
    (saleOrSellerIdentifier || "").trim() === "" || isCPF(removeExcessiveDigits(getDigits(saleOrSellerIdentifier!), 11));

  // Update the overall form validity to include the new criteria for saleOrSellerIdentifier.
  // Note: The component will need to use this 'updatedIsFormValid' for the button's disabled state,
  // and 'saleOrSellerIdentifierMeetsCriteria' for any related error messages.
  const updatedIsFormValid = isDealerEmailValid && saleOrSellerIdentifierMeetsCriteria;

  const handleCPFSellerChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const cpf = removeExcessiveDigits(getDigits(event.target.value), 11);
    setSaleOrSellerIdentifier(formatCPF(cpf));
  };

  const handleButtonClick = () => {
    if (!isFormValid) return;
    const dadosParceiro: DadosParceiroType = {
      idSalesforceParceiro: saleOrSellerIdentifier,
      emailDealer: dealerEmail,
    };
    setItemSession("DadosParceiro", JSON.stringify(dadosParceiro));
    navigate("/distribuidora");
  };

  const calculatorModalRef = useRef<NewModalRef>(null);
  const matches = useMediaQuery("(min-width: 1008px)");

  useEffect(() => {
    if (matches) calculatorModalRef.current?.close();
  }, [matches]);

  return (
    <MainHomeComponent>
      <LeftHomeComponent logoSrc={logoIvi} title={title} description={description} showCalculator={true} />
      <RightHomeComponent
        title={title}
        description={description}
        questionSrc={question}
        commentIconSrc={comentIcon}
        cardHomeClass="container-contact"
      >
        <div className="container-contact-form">
          {/* nome */}
          <div className="container-inputs-contact">
            <Input
              type="text"
              size="md"
              label="CPF do Vendedor"
              value={saleOrSellerIdentifier}
              onChange={(ev) => {
                // if (isSaleOrSellerIdentifierCPF) {
                handleCPFSellerChange(ev);
                return;
                // }
                // setSaleOrSellerIdentifier(ev.target.value);
              }}
              color="primary"
              classNames={{
                input: ["text-kumbh-sans"],
                label: ["font-kumbh-sans"],
                inputWrapper: ["w-[280px] h-14 bg-transparent data-[hover=true]:bg-transparent group-data-[focus=true]:bg-transparent"],
              }}
              inputMode="text"
            />
          </div>

          {!saleOrSellerIdentifierMeetsCriteria && <p className="error-mgs-contact">CPF inválido</p>}

          <div className="container-inputs-contact">
            <Input
              type="text"
              size="md"
              label="E-mail do Vendedor"
              value={dealerEmail}
              onChange={(ev) => {
                setDealerEmailChanged(true);
                setDealerEmail(ev.target.value);
              }}
              color="primary"
              isInvalid={!isDealerEmailValid && dealerEmailChanged}
              classNames={{
                input: ["text-kumbh-sans"],
                label: ["font-kumbh-sans"],
                inputWrapper: ["w-[280px] h-14 bg-transparent data-[hover=true]:bg-transparent group-data-[focus=true]:bg-transparent"],
              }}
              inputMode="email"
            />
          </div>
          {!isDealerEmailValid && dealerEmailChanged && <p className="error-mgs-contact">E-mail inválido</p>}

          <div className="container-button-contact">
            <ButtonComponent
              className="continue-button"
              // className="btn-continue-contact"
              style={{ width: "300px" }}
              onClick={handleButtonClick}
              isDisabled={!updatedIsFormValid}
            >
              Gerar uma proposta agora
            </ButtonComponent>
          </div>
          {type === FluxoType.CONSULTOR && (
            <>
              <ButtonComponent
                className="min-[1008px]:hidden underline underline-offset-2"
                onClick={() => calculatorModalRef.current?.open()}
              >
                Simular economia
              </ButtonComponent>

              <CalculatorModal ref={calculatorModalRef} />
            </>
          )}
        </div>
      </RightHomeComponent>
    </MainHomeComponent>
  );
};
